import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link className="navbar-link" to="/">Home</Link>
          <Link className="navbar-link" to="/portfolio">Portfolio</Link>
          <Link className="navbar-link" to="/map">Map</Link>
          <Link className="navbar-link" to="/globe">Globe</Link>
          <Link className="navbar-link" to="/contact">Contact</Link>
          <Link className="navbar-link" to="/about">About</Link>
        </div>
      </div>
    </nav>
  );
}
